// import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  const CACHE = {};

  class ProductNew extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mainSwiperEl = this.querySelector("[data-main-swiper]");
      this.thumbSwiperEl = this.querySelector("[data-thumbs-swiper]");
      CACHE[window.location.toString()] = this.outerHTML;
      this.initSwipers();

      if (this.hasAttribute("data-disable-url-updates")) {
        this.onPdpVariantChange = this.onPdpVariantChange.bind(this);
        window.addEventListener("pdp:variant:change", this.onPdpVariantChange);
        this.onPageShow = this.onPageShow.bind(this);
        window.addEventListener("pageshow", this.onPageShow);
      }
    }

    disconnectedCallback() {
      if (this.onPdpVariantChange) {
        window.removeEventListener("pdp:variant:change", this.onPdpVariantChange);
      }
      if (this.onPageShow) {
        window.removeEventListener("pageshow", this.onPageShow);
      }
    }

    onPageShow(event) {
      if (!event.persisted || !this.hasAttribute("data-disable-url-updates")) return;

      document.body.classList.remove("loading");
      this.destroySwipers();
      this.mainSwiperEl = this.querySelector("[data-main-swiper]");
      this.thumbSwiperEl = this.querySelector("[data-thumbs-swiper]");
      if (this.mainSwiperEl && this.thumbSwiperEl) {
        this.initSwipers();
      }
    }

    destroySwipers() {
      if (this.mainSwiper?.destroy) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }
      if (this.thumbSwiper?.destroy) {
        this.thumbSwiper.destroy(true, true);
        this.thumbSwiper = null;
      }
    }

    onPdpVariantChange(event) {
      const { featuredMediaId } = event.detail || {};
      this.goToMedia(featuredMediaId);
    }

    goToMedia(mediaId) {
      if (!mediaId || !this.mainSwiper) return;

      const slides = Array.from(this.mainSwiper.slides);
      const index = slides.findIndex(
        (slide) => slide.dataset?.mediaId === String(mediaId)
      );

      if (index < 0) return;

      if (typeof this.mainSwiper.slideToLoop === "function") {
        this.mainSwiper.slideToLoop(index);
      } else {
        this.mainSwiper.slideTo(index);
      }
    }

    initSwipers() {
      if (!this.mainSwiperEl || !this.thumbSwiperEl) return;

      const initialSlide = parseInt(
        this.mainSwiperEl.querySelector("[data-is-selected]")?.dataset
          ?.isSelected || 0
      );

      this.thumbSwiper = new Swiper(this.thumbSwiperEl, {
        slidesPerView: 6,
        spaceBetween: 8,
      });

      const nextEl = this.querySelector("[data-main-swiper-next]");
      const prevEl = this.querySelector("[data-main-swiper-prev]");

      this.mainSwiper = new Swiper(this.mainSwiperEl, {
        loop: true,
        initialSlide,
        navigation: { nextEl, prevEl },
        thumbs: { swiper: this.thumbSwiper },
      });

      this.mainSwiper.on('slideChange', function (swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide?.querySelector('video');

        if (!activeVideo) {
          return;
        }

        activeVideo.play();
      });
    }

    loading(state) {
      if (state) {
        document.body.classList.add("loading");
      } else {
        document.body.classList.remove("loading");
        window.StampedFn?.reloadUGC();
        window.dispatchEvent(new Event("load"));
      }
    }

    async replaceLayout(url) {
      this.loading(true);

      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set("section_id", this.dataset.sectionId);

      if (!this.hasAttribute("data-disable-url-updates")) {
        window.history.replaceState({}, "", url);
      }

      const cacheKey = fetchUrl.toString();

      if (CACHE[cacheKey]) {
        this.outerHTML = CACHE[cacheKey];
        this.loading(false);
        return;
      }
      const res = await fetch(fetchUrl);
      const html = await res.text();
      const newDocument = new DOMParser().parseFromString(html, "text/html");
      const newHTML = newDocument.querySelector("product-new").outerHTML;
      CACHE[cacheKey] = newHTML;

      this.outerHTML = newHTML;
      this.loading(false);
    }
  }

  if (!customElements.get("product-new"))
    customElements.define("product-new", ProductNew);
})();
